import { createSlice } from "@reduxjs/toolkit";
import { UserDataPropType } from "./types";

const initialStateValue: UserDataPropType = {
  id: "",
  email: "",
  user_type: "",
  created_at: "",
  updated_at: "",
  loggedIn: false,
  firstname: "",
  lastname: "",
  phone_number: "",
  email_verified_at: "",
  name: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState: { value: initialStateValue },
  reducers: {
    login: (state, action) => {
      // Set Token
      sessionStorage.setItem("accessToken", action.payload.access_token);
      if (action.payload.remember_me) {
        localStorage.setItem("accessToken", action.payload.access_token);
      }
      state.value = action.payload;
    },
    setUser: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },

    logout: (state) => {
      localStorage.clear();
      sessionStorage.clear();
      state.value = initialStateValue;
    },
  },
});

export const { login, setUser, logout } = userSlice.actions;
export default userSlice.reducer;
